import React, { useState, useContext, useEffect, useRef, Fragment } from 'react'
import {
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Button,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import PlacesAutocomplete from '../shared/PlacesAutoComplete'
import { AuthenticationContext } from '../../Auth/authentication.context'
import { useBranding } from '../../contexts/BrandingContext'
import { Checkbox } from 'primereact/checkbox'
import { Tooltip } from 'primereact/tooltip'
import { convertLength } from '@mui/material/styles/cssUtils'
import PaymentModal from '../shared/PaymentModal'
import BankInfoModal from '../shared/BankInfoModal'
import DeleteModal from '../shared/DeleteModal'
import server from '../../server'
import { Message } from 'primereact/message'

const PharmacyProfileDetails = ({ user, reloadData, loading, userId: propUserId }) => {
  const { isGroupMode } = useBranding()
  const getCurrentPharmacyGroupId = (u) =>
    u?.pharmacy?.pharmacyGroup?.id ??
    u?.pharmacyGroup?.id ??
    u?.pharmacyGroupId ??
    u?.pharmacy?.pharmacyGroupId ??
    null
  const [ownerPhone, setOwnerPhone] = useState(
    user?.pharmacyOwnerTelephone || ''
  )
  console.log('user', user)
  const [ownerEmail, setOwnerEmail] = useState(
    user?.pharmacyOwnerEmail || ''
  )
  const [editDisplayName, setEditDisplayName] = useState(
    user?.displayName || ''
  )
  const [editMode, setEditMode] = useState(false)
  const [editName, setEditName] = useState(user?.legalName || '')
  const [editPharmacyName, setEditPharmacyName] = useState(
    user?.pharmacyName || ''
  )
  const [editTelephone, setEditTelephone] = useState(
    user?.telephone || ''
  )
  const [userStatus, setUserStatus] = useState(user?.status)
  const [selectedAddress, setSelectedAddress] = useState(null)
  const [userLoading, setUserLoading] = useState(false)
  const [isOwnerContactDifferent, setIsOwnerContactDifferent] = useState(false)
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null)
  const [editTradeName, setEditTradeName] = useState(
    user?.tradeName || ''
  )
  const [editPharmacyOwnerName, setEditPharmacyOwnerName] = useState(
    user?.pharmacyOwnerName || ''
  )
  const [editFax, setEditFax] = useState(user?.fax || '')
  const [isPharmacistInfoDifferent, setIsPharmacistInfoDifferent] =
    useState(false)
  const [editAccreditation, setEditAccreditation] = useState(
    user?.accreditation || ''
  )
  const [selectedStatus, setSelectedStatus] = useState(
    user?.status || 'Pending'
  )
  const [statusOptions, setStatusOptions] = useState([
    'Approved',
    'Rejected',
    'Pending',
  ])
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [pharmacyGroups, setPharmacyGroups] = useState([])
  const [selectedPharmacyGroup, setSelectedPharmacyGroup] = useState(
    getCurrentPharmacyGroupId(user)
  )
  const [pharmacyGroupsLoading, setPharmacyGroupsLoading] = useState(false)
  const [pharmacyGroupSaving, setPharmacyGroupSaving] = useState(false)
  const pharmacyGroupSelectRef = useRef(null)

  const { onProfileUpdate, success, status, isAdmin } = useContext(AuthenticationContext)
  const [systemsEditData, setSystemsEditData] = useState([])
  
  // Debug: Log isAdmin value
  useEffect(() => {
    console.log('PharmacyProfileDetails - isAdmin:', isAdmin)
  }, [isAdmin])

  const [originsDirectModule, setOriginsDirectModule] = useState(null)
  const [originsManagementModule, setOriginsManagementModule] = useState(null)
  const [originsInstanceModule, setOriginsInstanceModule] = useState(null)
  const [systemsLoading, setSystemsLoading] = useState(false)
  const [systemError, setSystemError] = useState('')
  const [profileError, setProfileError] = useState('')

  // A pharmacy's profile is considered complete once these core fields have
  // been saved. Until then, the next edit is treated as their "first time"
  // completing the profile, where every field except fax is mandatory.
  const isPharmacyProfileComplete = !!(
    user?.legalName &&
    user?.tradeName &&
    user?.telephone &&
    user?.shippingAddress &&
    user?.pharmacyOwnerName
  )

  const [paymentProfile, setPaymentProfile] = useState(null)
  const [bankProfile, setBankProfile] = useState(null)
  const [paymentModalVisible, setPaymentModalVisible] = useState(false)
  const [bankInfoModalVisible, setBankInfoModalVisible] = useState(false)
  const [deleteModalVisible, setDeleteModalVisible] = useState(false)
  const [deleteBankModalVisible, setDeleteBankModalVisible] = useState(false)
  const [profileToDelete, setProfileToDelete] = useState(null)
  const [bankProfileToDelete, setBankProfileToDelete] = useState(null)
  const [profileLoading, setProfileLoading] = useState(false)
  const [paymentProfileLoading, setPaymentProfileLoading] = useState(false)
  const [bankProfileLoading, setBankProfileLoading] = useState(false)
  const [showTooltip, setShowTooltip] = useState(false)

  console.log('systemsEditData', systemsEditData)
  useEffect(() => {
    const systemsData =
      user?.pharmacyModules?.map((module) => module.name) || []
    setSystemsEditData(systemsData)

    const originsDirect = systemsData.includes('Origins Direct')
    setOriginsDirectModule(originsDirect)

    const originsManagement = systemsData.includes('Origins Management')
    setOriginsManagementModule(originsManagement)

    const originsInstance = systemsData.includes('Origins Direct Instant')
    setOriginsInstanceModule(originsInstance)

    // Sync status from user when data loads so we don't persist wrong default (e.g. Pending when actually Approved)
    const statusFromUser = user?.status ?? user?.pharmacy?.status
    if (statusFromUser != null) {
      setSelectedStatus(statusFromUser)
    } else {
      setSelectedStatus('Pending')
    }

    // Set pharmacy group from user data only when not in edit mode (so we don't overwrite user's "No Group" selection)
    if (!editMode) {
      setSelectedPharmacyGroup(getCurrentPharmacyGroupId(user))
    }
  }, [user, editMode])

  // Fetch pharmacy groups (only for admins)
  useEffect(() => {
    const fetchPharmacyGroups = async () => {
      // Only fetch if user is admin
      if (isAdmin !== true) {
        return
      }
      
      setPharmacyGroupsLoading(true)
      try {
        const response = await server.get('/pharmacyGroups')
        if (response.data?.pharmacyGroups) {
          setPharmacyGroups(response.data.pharmacyGroups)
        }
      } catch (error) {
        console.error('Error fetching pharmacy groups:', error)
      } finally {
        setPharmacyGroupsLoading(false)
      }
    }
    fetchPharmacyGroups()
  }, [isAdmin])

  const getUserById = async (userId) => {
    try {
      // Only proceed if userId is valid
      if (!userId) {
        console.log('No user ID available')
        return
      }

      const response = await server.get(`/users/get-users?id=${userId}`)

      if (
        response.data &&
        response.data.users &&
        response.data.users.length > 0
      ) {
        setUserStatus(response.data.users[0]?.status)

        // Also get pharmacy statuses for dropdown options
        const statuses = response.data.users[0]?.possibleStatuses || [
          'Approved',
          'Rejected',
          'Pending',
        ]
        setStatusOptions(statuses)
      }
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }
  useEffect(() => {
    const fetchProfiles = async () => {
      if (user?.id) {
        setProfileLoading(true)
        try {
          // Payment/bank APIs expect pharmacy id (pharmacies.id), not user id
          const pharmacyId = user?.pharmacy?.id ?? user?.pharmacyModules?.[0]?.pharmacyId
          if (pharmacyId && !isGroupMode) {
            await Promise.all([
              fetchPaymentProfile(pharmacyId),
              fetchBankProfile(pharmacyId),
            ])
          } else {
            setPaymentProfile(null)
            setBankProfile(null)
          }
        } catch (error) {
          console.error('Error fetching profiles:', error)
        } finally {
          setProfileLoading(false)
        }
      }
      getUserById(user?.id)
    }

    fetchProfiles()
  }, [user, isGroupMode])

  const onSystemChange = (e, moduleName) => {
    const isChecked = e.checked

    // Prevent unchecking if it's the last checked system
    if (!isChecked && systemsEditData.length === 1) {
      setSystemError('At least one system must be selected')
      return
    }
    setSystemError('')

    if (moduleName === 'Origins Direct') {
      setOriginsDirectModule(isChecked)
    } else if (moduleName === 'Origins Management') {
      setOriginsManagementModule(isChecked)
    } else if (moduleName === 'Origins Direct Instant') {
      setOriginsInstanceModule(isChecked)
    }

    const updatedSystemsEditData = isChecked
      ? [...systemsEditData, moduleName]
      : systemsEditData.filter((name) => name !== moduleName)

    setSystemsEditData(updatedSystemsEditData)
  }

  const handlePharmacyGroupSave = async () => {
    try {
      if (pharmacyGroupSaving) return
      setPharmacyGroupSaving(true)

      const currentGroupId = getCurrentPharmacyGroupId(user)
      // Read from ref (DOM) so we get the value the user just selected even if state hasn't flushed yet
      const rawValue = pharmacyGroupSelectRef.current?.value
      const valueFromSelect =
        rawValue === '' || rawValue == null || rawValue === undefined
          ? null
          : Number(rawValue)
      const normalizedSelected = Number.isNaN(valueFromSelect) ? null : valueFromSelect
      const normalizedCurrent =
        currentGroupId === '' ||
        currentGroupId === null ||
        currentGroupId === undefined ||
        Number.isNaN(Number(currentGroupId))
          ? null
          : Number(currentGroupId)

      // Try multiple ways to get the user ID
      const userId = propUserId || user?.id || user?.userId
      if (!userId) {
        console.error('User ID is missing. User object:', user, 'propUserId:', propUserId)
        alert('Error: User ID is missing. Please refresh the page and try again.')
        return
      }

      console.log('Saving pharmacy group:', {
        userId,
        normalizedSelected,
        normalizedCurrent,
        userRole: user?.role,
        isAdmin,
        pharmacyId: user?.pharmacy?.id,
        userObjectId: user?.id,
        propUserId,
        pharmacyUserId: user?.pharmacy?.userId
      })

      // For admin users updating another user's pharmacy, use direct API call
      // This ensures we're using the correct endpoint
      // The backend expects the user ID (not pharmacy ID) in the URL
      // and looks up the pharmacy by userId: id in the pharmacies table
      if (isAdmin === true && userId) {
        try {
          console.log('Making API call to update pharmacy group:', {
            endpoint: `/users/${userId}`,
            pharmacyGroupId: normalizedSelected,
            userId,
            userRole: user?.role,
            pharmacyUserId: user?.pharmacy?.userId
          })

          const response = await server.patch(
            `/users/${userId}`,
            {
              pharmacyGroupId: normalizedSelected
            },
            {
            }
          )
          
          console.log('Pharmacy group saved successfully:', response.data)
          
          // Close edit mode for the entire page (like other sections)
          setEditMode(false)
          
          // Reload data to show updated pharmacy group - wait a bit for backend to process
          if (reloadData) {
            // Wait a bit longer to ensure backend has processed the update
            setTimeout(() => {
              reloadData()
            }, 500)
          }
        } catch (apiError) {
          console.error('API Error saving pharmacy group:', apiError)
          console.error('Error details:', {
            status: apiError.response?.status,
            data: apiError.response?.data,
            userId,
            userRole: user?.role
          })
          console.error('Error saving pharmacy group:', apiError.response?.data || apiError.message)
        }
      } else {
        // Fallback to onProfileUpdate for non-admin or when userId is not available
        await onProfileUpdate(
          editDisplayName || user?.displayName || '',
          editName || user?.legalName || '',
          editTradeName || user?.tradeName || '',
          editAccreditation || user?.accreditation || '',
          selectedAddress || user?.address || null,
          editTelephone || user?.telephone || '',
          editFax || user?.fax || '',
          selectedShippingAddress || user?.shippingAddress || null,
          editPharmacyOwnerName || user?.pharmacyOwnerName || '',
          isOwnerContactDifferent ? ownerPhone : (user?.pharmacyOwnerTelephone || user?.pharmacy?.pharmacyOwnerTelephone || null),
          isOwnerContactDifferent ? ownerEmail : (user?.pharmacyOwnerEmail || user?.pharmacy?.pharmacyOwnerEmail || null),
          userId,
          systemsEditData || user?.pharmacyModules?.map((m) => m.name) || [],
          selectedStatus || user?.status || user?.pharmacy?.status || 'Pending',
          normalizedSelected
        )
        
        // Reload data to show updated pharmacy group
        if (reloadData) {
          reloadData()
        }
      }
    } catch (error) {
      console.error('Error saving pharmacy group:', error)
      const errorMessage = error.response?.data?.message || error.message || 'Failed to save pharmacy group'
      alert('Error saving pharmacy group: ' + errorMessage)
    } finally {
      setPharmacyGroupSaving(false)
    }
  }

  const handleEditSubmit = () => {
    // The first time a pharmacy completes their own profile, every pharmacy
    // and manager field is mandatory except the fax number. This is only
    // enforced for the pharmacy editing their own account (not for admins).
    if (!isAdmin && !isPharmacyProfileComplete) {
      const resolvedShippingAddress =
        selectedShippingAddress || user?.shippingAddress
      const requiredFields = {
        'Legal Name': editName,
        'Trade Name': editTradeName,
        'Shipping Address': resolvedShippingAddress,
        'Telephone Number': editTelephone,
        Accreditation: editAccreditation,
        'Pharmacy Owner Name': editPharmacyOwnerName,
      }

      if (isOwnerContactDifferent) {
        requiredFields['Pharmacy Owner Telephone'] = ownerPhone
        requiredFields['Pharmacy Owner Email'] = ownerEmail
      }

      const missingFields = Object.entries(requiredFields)
        .filter(([, value]) => !value || `${value}`.trim() === '')
        .map(([label]) => label)

      if (missingFields.length > 0) {
        setProfileError(
          `Please complete all required fields (only Fax is optional): ${missingFields.join(
            ', '
          )}.`
        )
        return
      }
    }
    setProfileError('')

    // Create an object to store only the changed values
    const updatedFields = {}
    console.log('updatedFields', updatedFields)

    // Only add fields that have changed
    if (editDisplayName !== user?.displayName) {
      updatedFields.displayName = editDisplayName
    }

    if (editName !== user?.legalName) {
      updatedFields.legalName = editName
    }

    if (editTradeName !== user?.tradeName) {
      updatedFields.tradeName = editTradeName
    }

    if (editPharmacyName !== user?.pharmacyName) {
      updatedFields.pharmacyName = editPharmacyName
    }

    if (selectedAddress) {
      updatedFields.address = selectedAddress
    }

    if (editTelephone !== user?.telephone) {
      updatedFields.telephone = editTelephone
    }

    if (editFax !== user?.fax) {
      updatedFields.fax = editFax
    }

    if (selectedShippingAddress) {
      updatedFields.shippingAddress = selectedShippingAddress
    }

    if (editPharmacyOwnerName !== user?.pharmacyOwnerName) {
      updatedFields.pharmacyOwnerName = editPharmacyOwnerName
    }

    if (editAccreditation !== user?.accreditation) {
      updatedFields.accreditation = editAccreditation
    }

    // Handle owner contact information
    const updatedPharmacyOwnerTelephone = isOwnerContactDifferent
      ? ownerPhone
      : null

    const updatedPharmacyOwnerEmail = isOwnerContactDifferent
      ? ownerEmail
      : null

    if (
      updatedPharmacyOwnerTelephone !== user?.pharmacyOwnerTelephone
    ) {
      updatedFields.pharmacyOwnerTelephone = updatedPharmacyOwnerTelephone
    }

    if (updatedPharmacyOwnerEmail !== user?.pharmacyOwnerEmail) {
      updatedFields.pharmacyOwnerEmail = updatedPharmacyOwnerEmail
    }

    // Only mark status as changed when user data has loaded (avoid saving wrong default e.g. Pending)
    if (user != null && selectedStatus !== user?.status) {
      updatedFields.status = selectedStatus
    }

    const currentGroupId = getCurrentPharmacyGroupId(user)
    const normalizedGroupId =
      selectedPharmacyGroup === '' || selectedPharmacyGroup == null || Number.isNaN(Number(selectedPharmacyGroup))
        ? null
        : Number(selectedPharmacyGroup)
    if (normalizedGroupId !== (currentGroupId == null ? null : Number(currentGroupId))) {
      updatedFields.pharmacyGroupId = normalizedGroupId
    }

    console.log('   user?.id', user?.id)

    // Only make the API call if there are actual changes or status has changed
    if (
      Object.keys(updatedFields).length > 0 ||
      selectedStatus !== user?.status
    ) {
      onProfileUpdate(
        updatedFields.displayName || user?.displayName || '',
        updatedFields.legalName || user?.legalName || '',
        updatedFields.tradeName || user?.tradeName || '',
        editAccreditation,
        updatedFields.address || null,
        updatedFields.telephone || user?.telephone || '',
        updatedFields.fax || user?.fax || '',
        updatedFields.shippingAddress || null,
        updatedFields.pharmacyOwnerName ||
          user?.pharmacyOwnerName ||
          '',
        updatedFields.pharmacyOwnerTelephone,
        updatedFields.pharmacyOwnerEmail,
        user?.id,
        systemsEditData,
        updatedFields.status || user?.status, // Always pass the current status
        updatedFields.pharmacyGroupId !== undefined ? updatedFields.pharmacyGroupId : getCurrentPharmacyGroupId(user)
      )

      setEditMode(false)
      setUserLoading(true)
    } else {
      // No changes were made
      setEditMode(false)
    }
    console.log('updatedFields', updatedFields)
  }

  const handleSystemEditSubmit = () => {
    if (systemsEditData.length === 0) {
      setSystemError('Please select at least one system')
      return
    }
    setSystemError('')

    const updatedPharmacyOwnerTelephone = isOwnerContactDifferent
      ? ownerPhone
      : null

    const updatedPharmacyOwnerEmail = isOwnerContactDifferent
      ? ownerEmail
      : null

    onProfileUpdate(
      editDisplayName,
      editName,
      editTradeName,
      editAccreditation,
      selectedAddress,
      editTelephone,
      editFax,
      selectedShippingAddress,
      editPharmacyOwnerName,
      updatedPharmacyOwnerTelephone,
      updatedPharmacyOwnerEmail,
      user?.id,
      systemsEditData,
      selectedStatus // Always pass the current status
    )
    setEditMode(false)
    setSystemsLoading(true)
  }
  const handleOwnerContactChange = (e) => {
    setIsOwnerContactDifferent(e.checked)
    if (!e.checked) {
      // If checkbox is unchecked, clear the owner phone and email
      setOwnerPhone('')
      setOwnerEmail('')
    }
  }

  const pharmacyModules = user?.pharmacyModules.map((module, index) => (
    <span
      className='badge bg-primary rounded-pill text-light py-2 px-3 fw-bold mx-1'
      key={index}
    >
      {module.name}
    </span>
  ))

  useEffect(() => {
    if (success === true) {
      reloadData()
      setUserLoading(false)
      setSystemsLoading(false)
    }
  }, [success])
  useEffect(() => {
    if (loading === false) {
      setUserLoading(false)
    }
  }, [loading])

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen)
  const handleStatusSelect = (status) => {
    setSelectedStatus(status)
    setDropdownOpen(false)
  }

  const fetchPaymentProfile = async (pharmacyId) => {
    setPaymentProfileLoading(true)
    try {
      const response = await server.get(
        `/payments/pharmacy-payment-profile/${pharmacyId}`,
        {
        }
      )
      if (response?.data?.success === false || response?.data?.paymentProfile == null) {
        setPaymentProfile(null)
      } else if (response?.data?.paymentProfile) {
        setPaymentProfile(response.data.paymentProfile)
      } else {
        setPaymentProfile(null)
      }
    } catch (error) {
      // 404 / "Pharmacy not found" when wrong id or no profile yet - treat as no profile
      if (error.response?.status !== 404) {
        console.error('Error fetching payment profile:', error)
      }
      setPaymentProfile(null)
    } finally {
      setPaymentProfileLoading(false)
    }
  }

  const fetchBankProfile = async (pharmacyId) => {
    setBankProfileLoading(true)
    try {
      const response = await server.get(
        `/payments/pharmacy-bank-profile/${pharmacyId}`,
        {
        }
      )
      if (response?.data?.success === false || response?.data?.bankProfile == null) {
        setBankProfile(null)
      } else if (response?.data?.bankProfile) {
        setBankProfile(response.data.bankProfile)
      } else {
        setBankProfile(null)
      }
    } catch (error) {
      // 404 / "Pharmacy not found" when wrong id or no profile yet - treat as no profile
      if (error.response?.status !== 404) {
        console.error('Error fetching bank profile:', error)
      }
      setBankProfile(null)
    } finally {
      setBankProfileLoading(false)
    }
  }

  const handleDeleteClick = (pharmacyId) => {
    setProfileToDelete(pharmacyId)
    setDeleteModalVisible(true)
  }

  const confirmDeleteProfile = async () => {
    if (profileToDelete) {
      try {
        await server.delete(
          `/payments/pharmacy-payment-profile/${profileToDelete}`,
          {
          }
        )
        setPaymentProfile(null)
        setDeleteModalVisible(false)
        setProfileToDelete(null)
        console.log('Payment profile deleted successfully')
      } catch (error) {
        console.error('Error deleting payment profile:', error)
      }
    }
  }

  const handleDeleteBankClick = (pharmacyId) => {
    setBankProfileToDelete(pharmacyId)
    setDeleteBankModalVisible(true)
  }

  const confirmDeleteBankProfile = async () => {
    if (bankProfileToDelete) {
      try {
        await server.delete(
          `/payments/pharmacy-bank-profile/${bankProfileToDelete}`,
          {
          }
        )
        setBankProfile(null)
        setDeleteBankModalVisible(false)
        setBankProfileToDelete(null)
        console.log('Bank profile deleted successfully')
      } catch (error) {
        console.error('Error deleting bank profile:', error)
      }
    }
  }

  return (
    <>
      <div className='text-end mb-3 d-flex justify-content-end align-items-center'>
        {!editMode && (
          <span
            className=' rounded-2 me-3'
            style={{
              backgroundColor:
                user?.status === 'Approved'
                  ? '#f0f7ff'
                  : user?.status === 'Rejected'
                  ? '#fff1f0'
                  : '#f5f5f5',
              color:
                user?.status === 'Approved'
                  ? '#22c55e'
                  : user?.status === 'Rejected'
                  ? '#EF4444'
                  : '#74788d',
              border: `1px solid ${
                user?.status === 'Approved'
                  ? '#22c55e'
                  : user?.status === 'Rejected'
                  ? '#EF4444'
                  : '#74788d'
              }`,
              padding: '6px 12px',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            {user?.status}
          </span>
        )}
        {editMode && (
          <div className='me-3'>
            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggleDropdown}
              direction='center'
            >
              <DropdownToggle
                className='d-flex align-items-center justify-content-between '
                style={{
                  backgroundColor:
                    selectedStatus === 'Approved'
                      ? '#f0f7ff'
                      : selectedStatus === 'Rejected'
                      ? '#fff1f0'
                      : '#f5f5f5',
                  color:
                    selectedStatus === 'Approved'
                      ? '#22c55e'
                      : selectedStatus === 'Rejected'
                      ? '#EF4444'
                      : '#74788d',
                  border: `1px solid ${
                    selectedStatus === 'Approved'
                      ? '#22c55e'
                      : selectedStatus === 'Rejected'
                      ? '#EF4444'
                      : '#74788d'
                  }`,

                  padding: '5px 12px',
                  minWidth: '120px',
                  transition: 'all 0.2s ease',
                  boxShadow: 'none',
                  cursor: 'pointer',
                }}
              >
                <span>{selectedStatus}</span>
                <i
                  className='mdi mdi-chevron-down ml-2'
                  style={{ fontSize: '16px' }}
                ></i>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  style={{ color: '#22c55e' }}
                  onClick={() => handleStatusSelect('Approved')}
                >
                  Approved
                </DropdownItem>
                <DropdownItem
                  style={{ color: '#EF4444' }}
                  onClick={() => handleStatusSelect('Rejected')}
                >
                  Rejected
                </DropdownItem>
                <DropdownItem
                  style={{ color: '#74788d' }}
                  onClick={() => handleStatusSelect('Pending')}
                >
                  Pending
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        )}
        <div
          style={{ position: 'relative', display: 'inline-block' }}
          onMouseEnter={() => status > 0 && setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <Button
            type='submit'
            color='primary'
            disabled={status > 0}
            onClick={() => setEditMode((prevState) => !prevState)}
          >
            {editMode ? 'Back' : 'Edit Pharmacy'}
          </Button>
          {showTooltip && status > 0 && (
            <div
              style={{
                position: 'absolute',
                top: '100%',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#333',
                color: 'white',
                padding: '8px 12px',
                borderRadius: '4px',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                zIndex: 1000,
                marginTop: '5px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
              }}
            >
              To request changes to your profile information, please send your
              request to admin@originssystems.com
              <div
                style={{
                  position: 'absolute',
                  bottom: '100%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  border: '5px solid transparent',
                  borderBottomColor: '#333',
                }}
              />
            </div>
          )}
        </div>
      </div>

      <Row>
        <Col lg='12'>
          <Card>
            <CardBody>
              <div className='d-flex'>
                <div className='row row-cols-2 w-100'>
                  <div className='text-muted'>
                    <h4 className='mb-2'>{user?.pharmacyName}</h4>
                    <h6 className='mb-1'>Pharmacy</h6>
                  </div>
                  <div className='text-muted'>
                    <h4 className='mb-2'>{user?.accountNo}</h4>
                    <h6 className='mb-1'>Account Number</h6>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      <Card>
        <CardBody>
          {userLoading ? (
            <div className='d-flex justify-content-center align-items-center '>
              <Spinner color='primary' />
            </div>
          ) : (
            <>
              {!editMode && (
                <div className='row row-cols-2'>
                  <div className='mb-3'>
                    <h4 style={{ color: '#626ED4' }} className='mt-2 mb-2'>
                      Pharmacy Information
                    </h4>
                  </div>
                  <div></div>

                  {/* 1. Legal Name */}
                  <div className='form-group col '>
                    <Label className='form-label'>Legal Name</Label>
                    <p>{user?.legalName}</p>
                  </div>

                  {/* 2. Trade Name */}
                  <div className='form-group col'>
                    <Label className='form-label mt-2'>Trade Name</Label>
                    <p>{user?.tradeName}</p>
                  </div>

                  {/* 3. Address */}
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Address</Label>
                    <p>
                      {user?.address ? user?.address : 'There is no address'}
                    </p>
                  </div>

                  {/* 4. Shipping Address */}
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Shipping Address</Label>
                    <p>
                      {user?.shippingAddress
                        ? user?.shippingAddress
                        : 'There is no shipping address'}
                    </p>
                  </div>

                  {/* 5. Telephone Number */}
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Telephone Number</Label>
                    <p>
                      {user?.telephone
                        ? user?.telephone
                        : 'There is no Telephone Number'}
                    </p>
                  </div>

                  {/* 6. Fax */}
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Fax</Label>
                    <p>
                      {user?.fax
                        ? user?.fax
                        : 'There is no fax'}
                    </p>
                  </div>

                  {/* 7. Email */}
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Email</Label>
                    <p>{user?.email}</p>
                  </div>

                  {/* 8. Accreditation */}
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Accreditation</Label>
                    <p>
                      {user?.accreditation
                        ? user?.accreditation
                        : 'There is no accreditation'}
                    </p>
                  </div>

                  {/* Contact Person Section */}
                  <div className='col-12 mt-5'>
                    <h4 style={{ color: '#626ED4' }}>
                      Contact Person / Pharmacy Owner Information
                    </h4>
                  </div>

                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Name</Label>
                    <p>
                      {user?.pharmacyOwnerName
                        ? user?.pharmacyOwnerName
                        : 'There is no name'}
                    </p>
                  </div>
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>
                      Pharmacy Owner Telephone
                    </Label>
                    <p>
                      {user?.pharmacyOwnerTelephone
                        ? user?.pharmacyOwnerTelephone
                        : 'There is no pharmacy owner telephone'}
                    </p>
                  </div>
                  <div className='form-group col '>
                    <Label className='form-label mt-2'>Email</Label>
                    <p>
                      {user?.pharmacyOwnerEmail
                        ? user?.pharmacyOwnerEmail
                        : 'There is no pharmacy owner email'}
                    </p>
                  </div>
                </div>
              )}
              {editMode && (
                <div>
                  <form className=''>
                    <h4 style={{ color: '#626ED4' }} className='mt-2 mb-2'>
                      Pharmacy Information
                    </h4>
                    <div className='row row-cols-1 row-cols-sm-2'>
                      <div className='form-group col'>
                        <Label className='form-label mt-3'>Legal Name</Label>
                        <input
                          name='legalName'
                          className='form-control'
                          type='text'
                          placeholder={user?.legalName}
                          value={editName}
                          onChange={(e) => setEditName(e.target.value)}
                        />
                      </div>

                      <div className='form-group col'>
                        <Label className='form-label mt-3'>Trade Name</Label>
                        <input
                          name='tradeName'
                          className='form-control'
                          type='text'
                          placeholder={user?.tradeName}
                          value={editTradeName}
                          onChange={(e) => setEditTradeName(e.target.value)}
                        />
                      </div>

                      <div className='form-group col'>
                        <Label className='form-label mt-3'>Address</Label>
                        <input
                          name='address'
                          className='form-control'
                          type='text'
                          placeholder={user.address}
                          value={
                            selectedAddress !== null
                              ? selectedAddress
                              : user?.address || ''
                          }
                          onChange={(e) => setSelectedAddress(e.target.value)}
                          disabled={!isAdmin}
                        />
                      </div>

                      <div className='form-group col'>
                        <Label className='form-label mt-3'>
                          Shipping Address
                        </Label>
                        <PlacesAutocomplete
                          placeholder={user.shippingAddress}
                          setSelectedAddress={(e) =>
                            setSelectedShippingAddress(e)
                          }
                        />
                      </div>

                      <div className='form-group col'>
                        <Label className='form-label mt-3'>
                          Telephone Number
                        </Label>
                        <input
                          name='telephone'
                          className='form-control'
                          type='text'
                          placeholder={user?.telephone}
                          value={editTelephone}
                          onChange={(e) => setEditTelephone(e.target.value)}
                        />
                      </div>

                      <div className='form-group col'>
                        <Label className='form-label mt-3'>Fax Number</Label>
                        <input
                          name='fax'
                          className='form-control'
                          type='text'
                          placeholder={user?.fax}
                          value={editFax}
                          onChange={(e) => setEditFax(e.target.value)}
                        />
                      </div>

                      <div className='form-group col'>
                        <Label className='form-label mt-3'>Email</Label>
                        <input
                          name='UserEmail'
                          className='form-control'
                          placeholder={user.email}
                          type='text'
                          disabled={true}
                        />
                      </div>

                      <div className='form-group col'>
                        <Label className='form-label mt-3'>Accreditation</Label>
                        <input
                          name='accreditation'
                          className='form-control'
                          type='text'
                          placeholder={
                            user?.accreditation ||
                            'Enter accreditation'
                          }
                          value={editAccreditation}
                          onChange={(e) => setEditAccreditation(e.target.value)}
                        />
                      </div>

                    </div>

                    <>
                      <h4 style={{ color: '#626ED4' }} className='mt-4 mb-2'>
                        Contact Person / Pharmacy Owner Information
                      </h4>
                      <div></div>
                    </>

                    <div className='row'>
                      <div className='form-group col'>
                        <Label className='form-label mt-3'>Name</Label>
                        <input
                          name='pharmacyOwnerName'
                          className='form-control'
                          type='text'
                          placeholder={
                            user?.pharmacyOwnerName || 'Enter name'
                          }
                          value={editPharmacyOwnerName}
                          onChange={(e) =>
                            setEditPharmacyOwnerName(e.target.value)
                          }
                        />
                      </div>
                    </div>

                    <div className='row'>
                      <div className='form-group col'>
                        <div className='d-flex align-items-center mt-4 mb-1'>
                          <Checkbox
                            inputId='originsDirect'
                            name='Origins Direct'
                            value='Origins Direct'
                            checked={isOwnerContactDifferent}
                            onChange={handleOwnerContactChange}
                          />
                          <label htmlFor='originsDirect' className='mx-2 mb-0'>
                            Phone and email are different
                          </label>
                        </div>
                      </div>
                    </div>

                    {isOwnerContactDifferent && (
                      <>
                        <div className='row row-cols-1 row-cols-sm-2'>
                          <div className='form-group col'>
                            <Label className='form-label mt-3'>
                              Telephone Number
                            </Label>
                            <input
                              name='pharmacyOwnerTelephone'
                              className='form-control'
                              type='text'
                              placeholder={
                                user?.pharmacyOwnerTelephone
                                  ? user?.pharmacyOwnerTelephone
                                  : 'Enter Telephone Number'
                              }
                              value={ownerPhone || ''}
                              onChange={(e) => setOwnerPhone(e.target.value)}
                            />
                          </div>

                          {/* --------------------------- */}
                          <div className='form-group col'>
                            <Label className='form-label mt-3'>Email</Label>
                            <input
                              name='pharmacyOwnerEmail'
                              className='form-control'
                              type='text'
                              placeholder={
                                user?.pharmacyOwnerEmail
                                  ? user?.pharmacyOwnerEmail
                                  : 'Enter Email'
                              }
                              value={ownerEmail || ''}
                              onChange={(e) => setOwnerEmail(e.target.value)}
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {profileError && (
                      <div className='mt-3'>
                        <Message severity='error' text={profileError} />
                      </div>
                    )}

                    <div className='text-center mt-4 d-flex justify-content-end gap-3 col-12'>
                      <Button
                        color=''
                        className='btn btn-outline-primary'
                        onClick={() => {
                          setProfileError('')
                          setEditMode(false)
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type='submit'
                        color='primary'
                        onClick={(e) => {
                          e.preventDefault()
                          handleEditSubmit()
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </form>
                </div>
              )}
              <div className='col col-sm-6  col-lg-4 mt-3 '></div>
            </>
          )}
        </CardBody>
      </Card>
      {!isGroupMode && (
        <Card>
          <CardBody>
            {systemsLoading ? (
              <div className='d-flex justify-content-center align-items-center '>
                <Spinner color='primary' />
              </div>
            ) : (
              <>
                {!editMode && (
                  <div className='row row-cols-2'>
                    <div className='form-group col '>
                      <Label className='form-label'>Systems</Label>
                      <h4 className='m-0 d-flex flex-wrap gap-2'>
                        {pharmacyModules}
                      </h4>
                    </div>
                  </div>
                )}

                {editMode && (
                  <div>
                    <h4 className='card-title mb-4'>Edit Systems</h4>
                    <form className='row row-cols-3'>
                      <div className='form-group col'>
                        <div className='d-flex align-items-center'>
                          <Checkbox
                            inputId='originsDirect'
                            name='Origins Direct'
                            value='Origins Direct'
                            onChange={(e) => onSystemChange(e, 'Origins Direct')}
                            checked={originsDirectModule}
                          />
                          <label htmlFor='originsDirect' className='mx-2 mb-0'>
                            Origins Direct
                          </label>
                        </div>
                      </div>

                      <div className='form-group col'>
                        <div className='d-flex align-items-center'>
                          <Checkbox
                            inputId='originsManagement'
                            name='Origins Management'
                            value='Origins Management'
                            onChange={(e) =>
                              onSystemChange(e, 'Origins Management')
                            }
                            checked={originsManagementModule}
                          />
                          <label
                            htmlFor='originsManagement'
                            className='mx-2 mb-0'
                          >
                            Origins Management
                          </label>
                        </div>
                      </div>
                      <div className='form-group col'>
                        <div className='d-flex align-items-center '>
                          <Checkbox
                            inputId='originsDirectInstant'
                            name='Origins Direct Instant'
                            value='Origins Direct Instant'
                            onChange={(e) =>
                              onSystemChange(e, 'Origins Direct Instant')
                            }
                            checked={originsInstanceModule}
                            disabled={true}
                            title='This option is disabled'
                            style={{ cursor: 'not-allowed' }}
                          />
                          <label
                            htmlFor='originsDirectInstant'
                            className='mx-2 mb-0'
                            style={{ cursor: 'not-allowed', color: 'gray' }}
                          >
                            Origins Direct Instant
                          </label>
                        </div>
                      </div>

                      {/* Add error message display */}
                      {systemError && (
                        <div className='col-12'>
                          <small className='text-danger'>{systemError}</small>
                        </div>
                      )}

                      <div className='text-center mt-4 d-flex justify-content-end gap-3 col-12'>
                        <Button
                          color=''
                          className='btn btn-outline-primary'
                          onClick={() => setEditMode(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          type='submit'
                          color='primary'
                          onClick={(e) => {
                            e.preventDefault()
                            handleSystemEditSubmit()
                          }}
                        >
                          Save
                        </Button>
                      </div>
                    </form>
                  </div>
                )}
              </>
            )}
          </CardBody>
        </Card>
      )}
      
      {/* Pharmacy Group Section - Admin only */}
      {isAdmin === true && (
        <Card>
          <CardBody>
            {!editMode ? (
              <div className='row row-cols-2'>
                <div className='form-group col '>
                  <Label className='form-label'>Pharmacy Group</Label>
                  <p>
                    {(user?.pharmacy?.pharmacyGroup || user?.pharmacyGroup)
                      ? `${(user.pharmacy?.pharmacyGroup || user.pharmacyGroup).name} (${(user.pharmacy?.pharmacyGroup || user.pharmacyGroup).province})`
                      : 'No group assigned'}
                  </p>
                </div>
              </div>
            ) : (
              <div>
                <h4 className='card-title mb-4'>Pharmacy Group</h4>
                <div className='row'>
                  <div className='form-group col-12 col-md-6'>
                    <Label className='form-label'>Select Pharmacy Group</Label>
                    <select
                      ref={pharmacyGroupSelectRef}
                      name='pharmacyGroup'
                      className='form-control'
                      value={selectedPharmacyGroup ?? ''}
                      onChange={(e) => {
                        const raw = e.target.value
                        const next = (raw === '' || raw == null) ? null : parseInt(raw, 10)
                        setSelectedPharmacyGroup(Number.isNaN(next) ? null : next)
                      }}
                      disabled={pharmacyGroupsLoading}
                    >
                      <option value=''>No Group</option>
                      {pharmacyGroups.map((group) => (
                        <option key={group.id} value={group.id}>
                          {group.name} ({group.province})
                        </option>
                      ))}
                    </select>
                    {pharmacyGroupsLoading && (
                      <small className='text-muted'>Loading groups...</small>
                    )}
                  </div>
                </div>
                <div className='text-center mt-4 d-flex justify-content-end gap-3 col-12'>
                  <Button
                    color=''
                    className='btn btn-outline-primary'
                    onClick={() => {
                      // Reset to original value
                      setSelectedPharmacyGroup(getCurrentPharmacyGroupId(user))
                      setEditMode(false)
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type='button'
                    color='primary'
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      handlePharmacyGroupSave()
                    }}
                    disabled={pharmacyGroupSaving}
                  >
                    {pharmacyGroupSaving ? 'Saving...' : 'Save'}
                  </Button>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      )}
      {!isGroupMode && (
        <Card>
          <CardBody>
            <h4 style={{ color: '#626ED4' }} className=''>
              Payment and Banking Information
            </h4>
            <div className='mb-4 w-100 d-flex justify-content-start '>
              <Message
                className='w-100 text-start d-inline-block '
                severity='warn'
                text='In order to have access to the Origins Direct Instant platform for payments and fund transfers, please complete the fields below.'
              />
            </div>

            {profileLoading ? (
              <div className='d-flex justify-content-center'>
                <Spinner color='primary' />
              </div>
            ) : (
              <div className='row mt-3'>
                <div className='col-md-6'>
                  <div className='card border h-100'>
                    {paymentProfileLoading ? (
                      <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                        <Spinner color='primary' />
                        <p className='mt-2'>Loading payment information...</p>
                      </div>
                    ) : !paymentProfile ? (
                      <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                        <h5 className='mb-4'>Add a Payment Method</h5>
                        <Button
                          color=''
                          className='btn btn-outline-primary'
                          onClick={() => setPaymentModalVisible(true)}
                        >
                          <i className='mdi mdi-plus-circle-outline me-1'></i>{' '}
                          Add a Card
                        </Button>
                      </div>
                    ) : (
                      <div className='card-body p-4 d-flex flex-column justify-content-between'>
                        <div>
                          <p className='mb-0 fw-bold'>
                            <i className='mdi mdi-credit-card me-2'></i>
                            {paymentProfile.payment?.creditCard?.cardType || 'Visa'}{' '}
                            {paymentProfile.payment?.creditCard?.cardNumber.replace(
                              'XXXX',
                              ' ****'
                            )}
                          </p>
                        </div>

                        <div className='mt-4 d-flex gap-2'>
                          <Button
                            color=''
                            className='btn btn-outline-primary'
                            onClick={() => handleDeleteClick(user?.pharmacyModules?.[0]?.pharmacyId)}
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className='col-md-6'>
                  <div className='card border h-100'>
                    {bankProfileLoading ? (
                      <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                        <Spinner color='primary' />
                        <p className='mt-2'>Loading bank information...</p>
                      </div>
                    ) : !bankProfile ? (
                      <div className='card-body d-flex flex-column align-items-center justify-content-center p-4'>
                        <h5 className='mb-4'>Add a Bank Information</h5>
                        <Button
                          color=''
                          className='btn btn-outline-primary'
                          onClick={() => setBankInfoModalVisible(true)}
                        >
                          <i className='mdi mdi-plus-circle-outline me-1'></i>{' '}
                          Add a Bank Information
                        </Button>
                      </div>
                    ) : (
                      <div className='card-body p-4 d-flex flex-column justify-content-between'>
                        <div>
                          <p className='mb-0 fw-bold'>
                            <i className='mdi mdi-bank me-2'></i>
                            Account:{' '}
                            {bankProfile.payment?.bankAccount?.accountNumber.replace(
                              'XXXX',
                              ' ****'
                            )}
                          </p>
                          <div className='d-flex align-items-center mt-1'>
                            <span className='me-2 fw-bold'>
                              Account Holder Name:{' '}
                              {bankProfile.payment?.bankAccount?.nameOnAccount}
                            </span>
                          </div>
                        </div>

                        <div className='mt-4 d-flex gap-2'>
                          <Button
                            color=''
                            className='btn btn-outline-primary'
                            onClick={() => handleDeleteBankClick(user?.pharmacyModules?.[0]?.pharmacyId)}
                          >
                            Remove
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      )}
      <PaymentModal
        visible={paymentModalVisible}
        setVisible={setPaymentModalVisible}
        onSave={(cardData) => {
          // Here you would typically make an API call to save the card
          console.log('Card saved for pharmacy:', cardData.pharmacyId)
          console.log('Card data:', cardData)

          // After successful payment processing, refresh the payment profile data
          if (cardData.pharmacyId) {
            fetchPaymentProfile(cardData.pharmacyId)
          }
        }}
        apiLoginID={process.env.REACT_APP_AUTHORIZE_API_LOGIN_ID}
        clientKey={process.env.REACT_APP_AUTHORIZE_CLIENT_KEY}
        pharmacyId={user?.pharmacyModules?.[0]?.pharmacyId || ''}
        userId={user?.id || ''}
      />
      <BankInfoModal
        visible={bankInfoModalVisible}
        setVisible={setBankInfoModalVisible}
        onSave={(bankData) => {
          // Here you would typically make an API call to save the bank info
          console.log('Bank info saved for pharmacy:', bankData.pharmacyId)
          console.log('Bank data:', bankData)
          setBankProfile(bankData)

          // After successful bank info processing, refresh the bank profile data
          if (bankData.pharmacyId) {
            fetchBankProfile(bankData.pharmacyId)
          }
        }}
        apiLoginID={process.env.REACT_APP_AUTHORIZE_API_LOGIN_ID}
        clientKey={process.env.REACT_APP_AUTHORIZE_CLIENT_KEY}
        pharmacyId={user?.pharmacyModules?.[0]?.pharmacyId || ''}
        userId={user?.id || ''}
      />
      <DeleteModal
        state={deleteBankModalVisible}
        footer={
          <Fragment>
            <Button
              color='secondary'
              onClick={() => setDeleteBankModalVisible(false)}
            >
              Cancel
            </Button>
            <Button color='danger' onClick={confirmDeleteBankProfile}>
              Delete
            </Button>
          </Fragment>
        }
        header='Delete Bank Information'
        body='Are you sure you want to delete this bank information? This action cannot be undone.'
        setState={setDeleteBankModalVisible}
      />
      <DeleteModal
        state={deleteModalVisible}
        footer={
          <Fragment>
            <Button
              color='secondary'
              onClick={() => setDeleteModalVisible(false)}
            >
              Cancel
            </Button>
            <Button color='danger' onClick={confirmDeleteProfile}>
              Delete
            </Button>
          </Fragment>
        }
        header='Delete Payment Method'
        body='Are you sure you want to delete this payment method? This action cannot be undone.'
        setState={setDeleteModalVisible}
      />
    </>
  )
}

export default PharmacyProfileDetails
